const state = () => ({
    knowledgeDetail:{
        status:"UNPUBLISHED",
        name:"",
        dirName:"",
        currentVersion:"",
        previousPubVersion:{
            state:"",
            no:""
        },
        pendingApproval:false,
        managePermission:[],
        editPermission:[]
    },
    showDownloadBtn:false,
    textWatermarkStr:"",
    isReadStatus:true,
    previousEditVersion:null,
    openSubsection:false
})

const getters = {
    getKnowledge: (state) => {
        return state.knowledgeDetail;
    },
    getDownLoadBtn:(state) => {
        return state.showDownloadBtn;
    },
    getTextWatermarkStr:(state) => {
        return state.textWatermarkStr;
    },
    getDocumentStatus:(state) => {
        return state.isReadStatus
    },
    getPreviousEditVersion:(state) => {
        return state.previousEditVersion
    },
    getOpenSubsection:(state) => {
        return state.openSubsection
    }
}

const actions = {
    updateKnowledge({ commit }, knowledge) {
        commit("setKnowledge", knowledge);
    },
    updateDownLoadBtn({ commit }, downLoad) {
        commit("setDownLoadBtn", downLoad);
    },
    updateTextWatermarkStr({ commit }, textValue) {
        commit("setTextWatermarkStr", textValue);
    },
    updateDocumentStatus({ commit },status){
        commit('setDocumentStatus',status)
    },
    updatePreviousEditVersion({ commit },previousVersion){
        commit('setPreviousEditVersion',previousVersion)
    },
    updateOpenSubsection({ commit },openSubsection){
        commit('setOpenSubsection',openSubsection)
    }
}

const mutations = {
    setKnowledge(state, knowledge) {
        state.knowledgeDetail = knowledge;
    },
    setDownLoadBtn(state,downLoadBtn){
        state.showDownloadBtn = downLoadBtn;
    },
    setTextWatermarkStr(state,textValue){
        state.textWatermarkStr = textValue;
    },
    setDocumentStatus(state,status){
        state.isReadStatus = status;
    },
    setPreviousEditVersion(state,previousVersion){
        state.previousEditVersion = previousVersion
    },
    setOpenSubsection(state,openSubsection){
        state.openSubsection = openSubsection;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}